import { api } from '../../../services/api/client';
import type { VipProgram, VipApplication, VipFile } from '../../../types';

// ---------- Member ----------
export async function fetchVipPrograms(): Promise<VipProgram[]> {
  const { data } = await api.get<VipProgram[]>('/member/vip/programs');
  return data;
}

export interface VipApplicationPayload {
  vip_program_id: string;
  broker_name: string;
  account_number: string;
  account_name: string;
  submitted_equity: number;
  tradingview_username: string;
  member_note: string;
}

export async function createVipApplication(payload: VipApplicationPayload): Promise<VipApplication> {
  const { data } = await api.post<VipApplication>('/member/vip/applications', payload);
  return data;
}

export async function fetchMyVipApplications(): Promise<VipApplication[]> {
  const { data } = await api.get<VipApplication[]>('/member/vip/applications');
  return data;
}

export async function fetchMyVipApplication(id: string): Promise<VipApplication> {
  const { data } = await api.get<VipApplication>(`/member/vip/applications/${id}`);
  return data;
}

export async function uploadVipFile(id: string, file_url: string, file_type = 'screenshot'): Promise<VipFile> {
  const { data } = await api.post<VipFile>(`/member/vip/applications/${id}/files`, { file_url, file_type });
  return data;
}

// ---------- Admin ----------
export interface VipProgramPayload {
  name: string;
  description?: string;
  min_equity?: number;
  min_exist_equity?: number;
  max_inactive_days?: number;
  is_active?: boolean;
  join_instructions?: string;
  whatsapp_group_url?: string;
  telegram_group_url?: string;
  tiktok_url?: string;
  discord_group_url?: string;
}

export interface VipGroupInfo {
  program_id: string;
  program_name: string;
  join_instructions: string;
  whatsapp_group_url: string;
  telegram_group_url: string;
  tiktok_url: string;
  discord_group_url: string;
}

export async function fetchMyVipGroup(): Promise<VipGroupInfo | null> {
  const { data } = await api.get<VipGroupInfo | null>('/member/vip/group');
  return data;
}

export async function adminFetchVipPrograms(): Promise<VipProgram[]> {
  const { data } = await api.get<VipProgram[]>('/admin/vip/programs');
  return data;
}

export async function adminCreateVipProgram(payload: VipProgramPayload): Promise<VipProgram> {
  const { data } = await api.post<VipProgram>('/admin/vip/programs', payload);
  return data;
}

export async function adminUpdateVipProgram(id: string, payload: Partial<VipProgramPayload>): Promise<VipProgram> {
  const { data } = await api.put<VipProgram>(`/admin/vip/programs/${id}`, payload);
  return data;
}

export async function adminDeleteVipProgram(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/vip/programs/${id}`);
  return data;
}

export async function adminFetchVipApplications(): Promise<VipApplication[]> {
  const { data } = await api.get<VipApplication[]>('/admin/vip/applications');
  return data;
}

export async function adminFetchVipApplication(id: string): Promise<VipApplication> {
  const { data } = await api.get<VipApplication>(`/admin/vip/applications/${id}`);
  return data;
}

export interface VipReviewPayload {
  review_result: 'approved' | 'rejected' | 'review';
  equity_checked?: number;
  is_activity_valid?: boolean;
  is_exist_equity_valid?: boolean;
  portal_check_note?: string;
  violation_note?: string;
  admin_note?: string;
}

export async function adminReviewVipApplication(id: string, payload: VipReviewPayload): Promise<VipApplication> {
  const { data } = await api.post<VipApplication>(`/admin/vip/applications/${id}/review`, payload);
  return data;
}
